import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { pivotThemeDecorator } from './decorator'
import generateStaticStrategy from './staticStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotThemeDecorator(staticStrategy)
  return decoratedStrategy.composeDetailSearchFilter(filter, [], insights)
}

const generatePivotThemeStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generatePivotThemeStrategy
